import classNames from "classnames";
import React, { FC } from "react";

import { ODSColumn } from "../ODSColumn";
import { ODSAspectRatioKeeperProps } from "./ODSAspectRatioKeeper.types";

import "./css/index.css";

const ODSAspectRatioKeeper: FC<ODSAspectRatioKeeperProps> = ({
  className,
  aspectRatio = "11",
  ...rest
}) => {
  return (
    <ODSColumn
      aria-hidden="true"
      className={classNames(
        `ODSAspectRatioKeeper`,
        `ODSAspectRatioKeeper-${aspectRatio}`,
        className
      )}
      {...rest}
    />
  );
};

export default ODSAspectRatioKeeper;
